import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import HeroSection from 'components/HeroSection';
import Container from 'components/Container';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Link from 'components/Link';

const StyledBreadcrumb = styled(Link)`
  text-decoration: none;
`;

export default function SubCategoryHero({ title, description, category }) {
  return (
    <HeroSection variant="primary">
      <Container>
        <Stack gap="1rem" align="start">
          <StyledBreadcrumb to={category.path}>
            <Text variant="smallP" color="lightestTeal">
              {category.title}
            </Text>
          </StyledBreadcrumb>
          <Text as="h1" variant="f1.resources" color="white">
            {title}
          </Text>
          <Text variant="p.resources" color="textGray">
            {description}
          </Text>
        </Stack>
      </Container>
    </HeroSection>
  );
}

SubCategoryHero.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  category: PropTypes.shape({
    title: PropTypes.string,
    path: PropTypes.string,
  }),
};
